import { FC, useContext, useState } from "react";
import { UIContext } from "../../../../../shared/contexts";
import {
  ColSize,
  ContentSection,
  InputForm,
  Form,
  RowSize,
} from "../../../../../shared/components";
import { ValidateForm } from "../../../../../shared/utils";
import { ActionButton } from "@hdi-seguros/web-components.action-button";
import AuthenticationService from "../../../../../shared/services/authentication";
import { Form as FormAnt, message } from "antd";
import { translateCognitoError } from "../../../../../shared/contexts/auth/utils/utils";
import { AlertComponent } from "../../../../../shared/components/AlertComponent";
import './index.css'
export const ChangePasswordTab: FC = () => {
  const validateForm = new ValidateForm();
  const { isLoading, setIsLoading } = useContext(UIContext);
  const [showError, setShowError ] = useState(false);
  const [status, setStatus] = useState("");
  const [form] = FormAnt.useForm();

  const formItems: {
    label: string;
    name: string;
    size: 75 | 25 | 50;
    initialValue?: string;
  }[] = [
    { label: "Ingrese su contraseña actual", name: "old-password", size: 50 },
    { label: "Ingrese su nueva contraseña", name: "new-password", size: 50 },
    { label: "Repita su nueva contraseña", name: "new-again-password", size: 50 },
  ];

  const handleSubmit = async () => {
    setShowError(false);
    const oldPassword = form.getFieldValue("old-password") as string;
    const newPassword = form.getFieldValue("new-password") as string;
    const repeatPassword = form.getFieldValue("new-again-password") as string;
    
    if (newPassword !== repeatPassword) {
      setStatus("Las contraseñas no coinciden");
      setShowError(true);
      return;
    }

    try {
      setIsLoading(true);
      await AuthenticationService.changePassword(oldPassword, newPassword);

      form.resetFields();
      message.success("Se cambio con exito su contraseña")
    } catch (error: any) {
      let errorMessage = "Error desconocido. Intenta nuevamente.";      
      if (error.response?.data?.__type) {
        const cognitoErrorCode = error.response.data.__type;
        errorMessage = translateCognitoError(cognitoErrorCode);
      } else if (error.code) {
        errorMessage = translateCognitoError(error.code);
      } else if (error.message) {
        errorMessage = error.message;
      }
      message.error(errorMessage);
      return false;
    } finally {      
      setIsLoading(false);
    }
  };

  return (
    <div>
      <ContentSection level="h3" title="Cambio de Contraseña">
        <RowSize>
          <ColSize size={100}>
            <Form
              formProps={{
                form,
                autoComplete: "off",
                onFinish: handleSubmit,
                name: "change-password-form",
              }}
            >
              {formItems.map(({ label, name, size }) => (
                <ColSize key={name} size={size}>
                  <InputForm
                    formProps={{
                      label: label,
                      name: name,
                    }}
                    isPassword
                    inputProps={{ placeholder: label }}
                  />
                </ColSize>
              ))}
              <ActionButton
                type="primary"
                loading={isLoading}
                width={130}
                htmlType="submit"
                label="Enviar"
              />
              {
                showError && <AlertComponent className="change-password_alert" message={status} type="error"/>
              }
            </Form>
          </ColSize>
        </RowSize>
      </ContentSection>
    </div>
  );
};
